import { MeResponseSchema } from '@batiflow/contracts';
import { useCallback } from 'react';
import { useRuntime } from '@/app/providers/runtime-provider';

/**
 * Reloads GET /api/v1/me into the session store without the loading state of a full bootstrap
 * (which would replace the page with a skeleton): the header, the permissions and the user's
 * language follow what the server now says (profile or organisation changed).
 */
export function useRefreshSession(): () => Promise<void> {
  const { fetcher, sessionStore } = useRuntime();
  return useCallback(async () => {
    const response = await fetcher<unknown>({ method: 'GET', url: '/api/v1/me' });
    sessionStore.setState({ me: MeResponseSchema.parse(response.data) });
  }, [fetcher, sessionStore]);
}
